<div class="setup-block">
  <div class="container">
    <div class="card flex-grow-1 my-2">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="logo">
              <img src="/assets/tyre-buzzar-logo.png" alt="Tyre Buzzar Logo" width="100" />
            </div>
            @if (welRegHeader) {
            <div class="header">
              <P>Welcome to Registration process of TyBu
              </P>
            </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            @if (showForm4) {
            <form (ngSubmit)="verifySecondaryUser()" name="registerForm" [formGroup]="secondaryForm" class="p-3">
              <div class="header">
                <p>Setup your account</p>
              </div>
              <div class="form-group">
                <input formControlName="phoneNumber" id="phoneNumber"
                  class="form-control form-control-lg default-form-group-border" placeholder="Phone number*" required
                  type="number" (input)="onInput($event)" />
                @if (secondaryForm.get('phoneNumber')?.invalid && (secondaryForm.get('phoneNumber')?.dirty ||
                secondaryForm.get('phoneNumber')?.touched)) {
                <div class="errorText">
                  @if (secondaryForm.get('phoneNumber')?.errors?.['pattern']) {
                  <div>
                    <small class="text-danger">Please enter valid mobile number</small>
                  </div>
                  }
                  @if (secondaryForm.get('phoneNumber')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Mobile number is required</small>
                  </div>
                  }
                </div>
                }
              </div>
              <div class="mt-2 text-danger">
                <small class="text-danger">{{errorVerify}}</small>
              </div>
              <div class="text-center">
                <button class="btn app-btn-primary" type="submit" [disabled]="secondaryForm.invalid">
                  Verify
                  @if (isLoading) {
                  <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                  }
                </button>
              </div>
              @if (ifReg) {
              <div class="button-row text-center verify-links">
                <p>Registered Already? <a [routerLink]="['/home']">Sign In</a></p>
              </div>
              }
            </form>
            }

            @if (showForm5) {
            <form #form2="ngForm" name="registerForm2" [formGroup]="registerForm5" class="p-3">
              <div class="form-group">
                <label for="otp">Enter OTP</label>
                <input formControlName="otp" id="otp" class="form-control form-control-lg default-form-group-border"
                  placeholder="Enter OTP" type="number" required (input)="input($event)" />
                @if (registerForm5.get('otp')?.invalid && (registerForm5.get('otp')?.dirty ||
                registerForm5.get('otp')?.touched)) {
                <div class="errorText">
                  @if (registerForm5.get('otp')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Otp is required</small>
                  </div>
                  }
                </div>
                }
              </div>
              <div class="form-group position-relative">
                <label for="password">Enter password</label>
                <div class="position-relative">
                  <input formControlName="password" id="password"
                    class="form-control form-control-lg default-form-group-border pe-5"
                    [type]="hide ? 'password' : 'text'" placeholder="Password" required />
                  <div class="position-absolute end-0 top-50 translate-middle-y me-3 hide">
                    <fa-icon [icon]=" hide ? faEye : faEyeSlash" (click)="hide = !hide"
                      [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hide"></fa-icon>
                  </div>
                </div>
                @if (registerForm5.get('password')?.invalid && (registerForm5.get('password')?.dirty ||
                registerForm5.get('password')?.touched)) {
                <div class="errorText">
                  @if (registerForm5.get('password')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Password is required</small>
                  </div>
                  }
                </div>
                }
                @if (registerForm5.get('password')?.hasError('pattern')) {
                <div>
                  <small class="text-muted">Minimum of 6 characters with a uppercase, lowercase,
                    special character and a number required</small>
                </div>
                }
              </div>
              <div class="form-group">
                <label for="confirmPassword">Confirm password</label>
                <div class="position-relative">
                  <input formControlName="confirmPassword" id="confirmPassword"
                    class="form-control form-control-lg default-form-group-border pe-5"
                    [type]="hide1 ? 'password' : 'text'" placeholder="Confirm password" required />
                  <div class="position-absolute end-0 top-50 translate-middle-y me-3 hide">
                    <fa-icon [icon]=" hide1 ? faEye : faEyeSlash" (click)="hide1 = !hide1"
                      [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hide1"></fa-icon>
                  </div>
                </div>
                @if (registerForm5.get('confirmPassword')?.invalid && (registerForm5.get('confirmPassword')?.dirty ||
                registerForm5.get('confirmPassword')?.touched)) {
                <div class="errorText">
                  @if (registerForm5.get('confirmPassword')?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Password is required</small>
                  </div>
                  }
                </div>
                }
                @if (registerForm5.get('confirmPassword')?.value !== registerForm5.get('password')?.value &&
                registerForm5.get('confirmPassword')?.touched) {
                <div>
                  <small class="text-danger">Passwords do not match</small>
                </div>
                }
              </div>
              <div class="mt-2 text-danger">
                <small class="text-danger">{{errorVerify}}</small>
              </div>
              <div class="d-flex justify-content-between align-items-center flex-wrap pt-2">
                <button class="btn app-btn-primary m-1" (click)="resendOTP()">
                  Resend OTP
                  @if (loader) {
                  <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                  }
                </button>
                <button class="btn app-btn-primary m-1" [disabled]="registerForm5.invalid" (click)="onVerify5()">
                  Register
                  @if (isLoading) {
                  <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                  }
                </button>
              </div>
            </form>
            }

            @if (showForm3) {
            <form name="congratsForm" class="p-3">
              <div>
                <div class="cong-reg text-center">
                  <i class="fa-regular fa-check"></i>
                  <h2>Congratulations!</h2>
                  <p>Your registration successfully completed.</p>
                </div>
              </div>
              <div class="text-center">
                <button class="btn app-btn-primary" [routerLink]="['/home']">
                  Go to Login
                </button>
              </div>
            </form>
            }
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>